// LoadingState.jsx
// Modern loading state component for Market

import React from 'react';
import { styles } from './styles';

const LoadingState = () => {
  return (
    <div style={styles.loadingContainer} className="loading-container">
      <div style={styles.loadingSpinner} className="loading-spinner" />
      <p style={styles.loadingText}>Discovering amazing items for you...</p>
      <p style={{ 
        ...styles.loadingText, 
        fontSize: '14px', 
        color: '#999', 
        marginTop: '8px' 
      }}>
        Finding the best deals from your ISU community
      </p>
    </div>
  );
};

export default LoadingState;